<template>
  <div class="req-status">
    <p v-if="!data || data.length < 1" class="no_data">
      {{ $lange == "en" ? "No Data" : "暂无数据" }}
    </p>
    <e-charts
      v-else
      style="width: 100%"
      :options="options"
      auto-resize
    ></e-charts>
  </div>
</template>

<script>
// 请求数据-按状态

import ECharts from "../components/Charts.vue";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/grid";
import "echarts/lib/component/dataZoom";
import theme from "./theme";

export default {
  name: "RequestEmpBar",
  components: { ECharts },
  props: {
    data: {
      type: Array,
    },
  },
  computed: {
    options() {
      const seriesSumData = this.data.map((item) => ({
        name: item.code,
        value: item.counter,
      }));
      const seriesProcessData = this.data.map((item) => ({
        name: item.code,
        value: item.value,
      }));
      const max = this.data.reduce((pre, cur) => {
        return Math.max(pre, cur["counter"], cur["value"]);
      }, 10);
      const xAxisData = this.data.map((item) => item.code);
      const legendTotal = this.$lange == "en" ? "Total Requests" : "总请求";
      const legendProcess = this.$lange == "en" ? "Processing" : "处理中";
      return {
        ...theme,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: [legendTotal, legendProcess],
          top: 6,
          left: 32,
        },
        grid: {
          left: 16,
          right: 16,
          containLabel: true,
          show: true,
        },
        xAxis: {
          type: "category",
          data: xAxisData,
        },
        yAxis: {
          type: "value",
          max,
        },
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 60,
            zoomOnMouseWheel: "ctrl",
            moveOnMouseWheel: true,
          },
          {
            type: "slider",
            start: 0,
            end: 60,
            height: "14px",
            backgroundColor: "#FAFAFA",
            fillerColor: "#ddd",
            zoomLock: true,
            borderColor: "transparent",
            left: 20, //左边的距离
            right: 20, //右边的距离
            bottom: 4, //右边的距离
            handleStyle: {
              borderWidth: 0,
              opacity: 0,
            },
            showDataShadow: false, //是否显示数据阴影 默认auto
            showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
          },
        ],
        series: [
          {
            name: legendTotal,
            type: "bar",
            data: seriesSumData,
            label: {
              show: true,
              position: "top",
              formatter: (params) => (params.value ? params.value : ""),
            },
          },
          {
            name: legendProcess,
            type: "bar",
            data: seriesProcessData,
            label: {
              show: true,
              position: "top",
              formatter: (params) => (params.value ? params.value : ""),
            },
          },
        ],
      };
    },
  },
};
</script>

<style scoped>
.no_data {
  text-align: center;
  color: #86898f;
  /* align-self: center; */
  transform: translateY(-50%);
  position: relative;
  top: 50%;
  left: 0;
}
</style>
